module.exports = __webpack_public_path__ + "static/Avin Regmi.d8bdb762.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Avin Regmi.jpg
// module id = 1206
// module chunks = 6166952557895